"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_client_1 = require("@cian/http-client");
var http_client_2 = require("../http_client");
function createMakeRequest(apiBaseUrl) {
    return function (config) {
        var clientRequest = http_client_2.httpClient.makeRequest({
            body: JSON.stringify(config.body),
            method: 'POST',
            uri: http_client_1.mergeBaseUri(apiBaseUrl, {
                path: function (path) { return http_client_1.mergePaths(path, config.path); },
            }),
        });
        return new Promise(function (resolve, reject) {
            clientRequest.subscribe(function (response) { return response.subscribe(resolve, reject); }, reject);
        });
    };
}
function addNewbuildingToFavorites(apiBaseUrl, newbuildingId) {
    var makeRequest = createMakeRequest(apiBaseUrl);
    return makeRequest({
        body: { newbuildingId: newbuildingId },
        path: '/cian-api/site/v1/add-newbuilding-to-favorites/',
    });
}
exports.addNewbuildingToFavorites = addNewbuildingToFavorites;
function removeNewbuildingFromFavorites(apiBaseUrl, newbuildingId) {
    var makeRequest = createMakeRequest(apiBaseUrl);
    return makeRequest({
        body: { newbuildingId: newbuildingId },
        path: '/cian-api/site/v1/remove-newbuilding-from-favorites/',
    });
}
exports.removeNewbuildingFromFavorites = removeNewbuildingFromFavorites;



//////////////////
// WEBPACK FOOTER
// ./src/browser/utils/favorite_network.ts
// module id = 298
// module chunks = 2